export default {"src":"/_next/static/media/3-icon.98d102cb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};